import {useAppContext} from "../../contexts/AppContext";
import {useEffect, useState} from "react";
import baseUrl from "../../baseUrl";
import {useForm} from "../../hooks/useForm";
import {validate_new_company_form} from "./validate_new_company_form";
import {EditCompanyForm} from "./EditCompanyForm/EditCompanyForm";
import {CompanyDealsSettlements} from "./CompanyDealsSettlements/CompanyDealsSettlements";
import {requester} from "../../services/requester";


export const Companies = () => {
    const {companies, onNewCompanySubmit} = useAppContext();
    const [valueCompanyState, setValueCompanyState] = useState('');
    const [isShowButtonAddCompany, setIsShowButtonAddCompany] = useState(false);
    const [errors, setErrors] = useState({});
    const request = requester();

    const companies_options = [];
    companies.forEach(company => {
        companies_options.push({
            id: company.id, value: `${company.company_name}, ${company.city}, ${company.bullstat}`
        });
    })

    const onChangeCompanyState = (event) => {
        setValueCompanyState(event.target.value);
    }

    const toggleShowForm = () => {
        setIsShowButtonAddCompany(!isShowButtonAddCompany);
    }

    const {values: new_values, changeHandler: changeNewData, onSubmitInitialValues} = useForm({
        company_name: "",
        bullstat: "",
        accountable_person: "",
        address: "",
        city: "",
        phone: "",
        company_note: "",
    });

    useEffect(() => {
        const errors = validate_new_company_form(new_values);
        setErrors(errors);
    }, [new_values])

    const onSubmitNewData = (e) => {
        e.preventDefault();

        const city_name = `гр.${new_values.city}`

        const body = {
            bullstat: Number(new_values.bullstat),
            company_name: new_values.company_name,
            accountable_person: new_values.accountable_person,
            address: new_values.address,
            city: city_name,
            phone: new_values.phone,
            company_note: new_values.company_note,
        };

        request.post(`${baseUrl()}/companies`, body)
            .then(() => {
                setIsShowButtonAddCompany(false);
                onNewCompanySubmit()
                onSubmitInitialValues()
            })
            .catch(err => {
                if (err.message) {
                    alert(err.message);
                }
            })
    };

    return (<div>
        <div className="d-grid gap-2">
            <button onClick={toggleShowForm} className="btn btn-outline-secondary mt-3" type="button">Прибави ползвател
            </button>
        </div>
        {isShowButtonAddCompany && (
            <div className="row g-3 align-items-center mt-1">
                <form onSubmit={onSubmitNewData}>
                    <div className="row g-3 align-items-center">
                        <div className="col-2">
                            <label htmlFor="company_name" className="col-form-label">Фирма</label>
                        </div>
                        <div className="col-6" style={{marginLeft: "10px"}}>
                            <input className="col-11" id="company_name" type="text" name="company_name"
                                   placeholder="задължително поле"
                                   value={new_values.company_name}
                                   onChange={changeNewData}
                            />
                        </div>
                    </div>
                    <div style={{color: "var(--app-danger-fg)"}}>{errors.company_name}</div>
                    <div className="row g-3 align-items-center">
                        <div className="col-2">
                            <label htmlFor="accountable_person" className="col-form-label">Лице за контакт</label>
                        </div>
                        <div className="col-6" style={{marginLeft: "10px"}}>
                            <input className="col-11" id="accountable_person" type="text" name="accountable_person"
                                   placeholder="задължително поле"
                                   value={new_values.accountable_person}
                                   onChange={changeNewData}
                            />
                        </div>
                    </div>
                    <div className="row g-3 align-items-center">
                        <div className="col-2">
                            <label htmlFor="bullstat" className="col-form-label">Булстат/ЕГН</label>
                        </div>
                        <div className="col-6" style={{marginLeft: "10px"}}>
                            <input className="col-11" id="bullstat" type="number" name="bullstat"
                                   placeholder="задължително поле"
                                   value={new_values.bullstat}
                                   onChange={changeNewData}
                            />
                        </div>
                    </div>
                    <div style={{color: "var(--app-danger-fg)"}}>{errors.bullstat}</div>
                    <div className="row g-3 align-items-center">
                        <div className="col-2">
                            <label htmlFor="address" className="col-form-label">Адрес</label>
                        </div>
                        <div className="col-6" style={{marginLeft: "10px"}}>
                            <input className="col-11" id="address" type="text" name="address"
                                   placeholder="опционално поле"
                                   value={new_values.address}
                                   onChange={changeNewData}
                            />
                        </div>
                    </div>
                    <div className="row g-3 align-items-center">
                        <div className="col-2">
                            <label htmlFor="city" className="col-form-label">Град</label>
                        </div>
                        <div className="col-6" style={{marginLeft: "10px"}}>
                            <input className="col-11" id="city" type="text" name="city"
                                   placeholder="опционално поле"
                                   value={new_values.city}
                                   onChange={changeNewData}
                            />
                        </div>
                    </div>
                    <div className="row g-3 align-items-center">
                        <div className="col-2">
                            <label htmlFor="phone" className="col-form-label">Телефон</label>
                        </div>
                        <div className="col-6" style={{marginLeft: "10px"}}>
                            <input className="col-11" id="phone" type="text" name="phone"
                                   placeholder="опционално поле"
                                   value={new_values.phone}
                                   onChange={changeNewData}
                            />
                        </div>
                    </div>
                    <div className="row g-3 align-items-center">
                        <div className="col-2">
                            <label htmlFor="company_note" className="col-form-label">Забележка</label>
                        </div>
                        <div className="col-6" style={{marginLeft: "10px"}}>
                            <input className="col-11" id="company_note" type="text" name="company_note"
                                   placeholder="опционално поле"
                                   value={new_values.company_note}
                                   onChange={changeNewData}
                            />
                        </div>
                    </div>

                    <button type="submit" className="btn btn-secondary mt-3">Прибави</button>
                </form>
            </div>
        )}

        <div className="row g-3 align-items-center mt-1">
            <div className="col-1 me-3">
                <label htmlFor="company" className="col-form-label">Ползвател</label>
            </div>
            <div className="col-8">
                <input className="col-11" type="search" list="list-company" autoComplete="on"
                       value={valueCompanyState}
                       onChange={onChangeCompanyState}/>
                <datalist id="list-company">
                    {companies_options.map(d => <option key={d.id} value={d.value}/>)}
                </datalist>
            </div>
        </div>
        {valueCompanyState.split(',').length === 3 && (
            <>
                <EditCompanyForm valueCompanyState={valueCompanyState}/>
                <CompanyDealsSettlements valueCompanyState={valueCompanyState}/>
            </>
        )}

    </div>);
};
